import { defineMessages } from 'react-intl';

export default defineMessages({
  groupByText: {
    description: 'Grid Header - Group By Button Text',
    defaultMessage: 'Group By...',
    id: 'Wil/Rk',
  },
  groupByLabel: {
    description: 'Grid Header - Group By Icon button label',
    defaultMessage: 'Group By',
    id: 'PCV8Vr',
  },
  multipleFieldsSelectedLabel: {
    description: 'Grid Header - Group By Multiple Fields Text',
    defaultMessage: '{count} Fields',
    id: 'e3/gDB',
  },
  popoverSelectLabel: {
    description: 'Group By Popover Select Label Text',
    defaultMessage: 'Select fields you want to group orders by',
    id: '4TdZnR',
  },
  popoverSelectField: {
    description: 'Group By Popover Select Field Text',
    defaultMessage: 'Select a field',
    id: 'D6KLvr',
  },
  popoverCombineField: {
    description: 'Group By Popover Combine Field Text',
    defaultMessage: 'Combine with another field',
    id: 'bo4gWE',
  },
  blankValueDescriptor: {
    description: 'Group By Dropdown Select a field message',
    defaultMessage: 'Select a Field',
    id: 'fQjIam',
  },
});
